import { AvailableMergeTags } from '@app/constants/mergeTags';
import { OptionsType } from '../types';
import { MERGE_TAG_CHARACTER_COUNT } from '../constants';

export function cleanTextWithSpaceRemoval(text: string): string {
	return text
		.replace(/&nbsp;/g, ' ')
		.replace(/&amp;/g, '&')
		.replace(/&gt;/g, '>')
		.replace(/&lt;/g, '<');
}

export function clearTagFormatFromEditorText(text: string) {
	return cleanTextWithSpaceRemoval(
		text
			.replace(new RegExp(/\{\{\{/gi), '')
			.replace(new RegExp(/\}\}\}/gi), ''),
		// .replace(new RegExp(/\{\{\{(.*)\}\}\}/))
	);
}

export function addCustomAttributesToMergeTagOptions(
	options: OptionsType[],
	workspace: any,
) {
	const customAttributesArray = workspace?.customAttributes || [];
	if (!customAttributesArray.length) {
		return options;
	}
	const customAttributesOptionsArray: { label: string; value: string }[] = [];
	if (customAttributesArray.length) {
		customAttributesArray.map((attribute: any) => {
			customAttributesOptionsArray.push({
				label: `${attribute.displayName}`,
				value: `contact.customAttributes.${attribute.name}`,
			});
		});
	}

	return [...options, ...customAttributesOptionsArray];
}
export function replaceMergeToBraceFormat(
	text: string,
	workspace: any = [],
	mergeTagsToReplace?: { label: string; value: string }[],
) {
	let editedText = text || '';

	const customAttributes =
		workspace?.customAttributes?.map(
			(customAttribute: { displayName: string; name: string }) => {
				return {
					value: `contact.customAttributes.${customAttribute?.name}`,
					label: customAttribute?.displayName,
				};
			},
		) || [];

	const defaultMergeTags = [
		...AvailableMergeTags.emailSubjectTitle,
		...AvailableMergeTags.action,
		...customAttributes,
	];

	const mergeTags = mergeTagsToReplace?.length
		? [...mergeTagsToReplace, ...customAttributes]
		: defaultMergeTags;

	mergeTags.forEach(({ value, label }) => {
		editedText = editedText.replace(
			new RegExp(`{{{${value}}}}`, 'ig'),
			`[${label}]`,
		);
	});

	return editedText;
}

export function checkMergeTagsHasSpacingWarning(text: string) {
	const doubleMergeTagsRegex = /}}}{{{/;

	// Match chars before the merge tag, it matches any alphanumeric chars and special chard followed by '{{{'
	const prefixRegex = /[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{{{/;

	// Match chars after the merge tag, it matches '}}}' followed by any alphanumeric chars
	const suffixRegex = /}}}(?:[a-zA-Z0-9]|\.{1,}[a-zA-Z0-9])/;

	const doubleTagsMatches = text.match(doubleMergeTagsRegex);
	const charBeforeTagsMatches = text.match(prefixRegex);
	const charAfterTagsMatches = text.match(suffixRegex);

	return (
		!!doubleTagsMatches || !!charBeforeTagsMatches || !!charAfterTagsMatches
	);
}

export function checkHasSquareBracketMergeTags(text: string) {
	//Matches "{content]", "[content}" and "[content]"
	const squareBracketRegex = /\[.*?]|\{.*?]|\[.*?\}/g;

	const squareBracketMatches = text.match(squareBracketRegex);

	return !!squareBracketMatches;
}

export function checkHasCurlyBracesMergeTags(text: string) {
	// Regular expression to find all instances of curly brace groups
	const curlyBracesRegex = /\{+[^{}]+\}+/g;

	//We need to allow three curly braces, this is the format we actually store for merge tags
	const threeCurlyBracesRegex = /^\{\{\{[^{}]+\}\}\}$/;

	const curlyBracesMatches = text.match(curlyBracesRegex);

	if (!curlyBracesMatches) return false;

	for (const match of curlyBracesMatches) {
		if (!threeCurlyBracesRegex.test(match)) {
			return true;
		}
	}
	return false;
}

/** Calculates the character count of a text, counting merge tags as 25 characters each. */
export function getCharacterCountWithMergeTags(text: string): number {
	if (!text) return 0;
	// Regex to find merge tags like {{{storyteller.lastName}}}
	const mergeTagRegex = /\{\{\{[^{}]+\}\}\}/g;

	// Remove leading and trailing new lines
	if (text.startsWith('\n') || text.endsWith('\n')) {
		text = text.replace('\n', '');
	}

	// Find all merge tags in the text
	const mergeTags = text.match(mergeTagRegex) || [];

	// Replace all merge tags with empty strings to get remaining text
	const textWithoutMergeTags = text.replace(mergeTagRegex, '');

	// Count merge tags as MERGE_TAG_CHARACTER_COUNT characters each, plus the length of remaining text
	return (
		textWithoutMergeTags.length + mergeTags.length * MERGE_TAG_CHARACTER_COUNT
	);
}
